import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/index-of";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InlinePrompt from "@Shared/components/general/inline-prompt";
import TextSection from "@Shared/components/sections/text-section";
import SelectSection from "@Shared/components/sections/select-section";
import { validationMixin } from "vuelidate";
import { requiredIf, required, email } from "vuelidate/lib/validators";
import { capitalize, cloneDeep, debounce, map } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ESignSelectSignersPage",
  components: {
    InlinePrompt,
    TextSection,
    SelectSection
  },
  mixins: [validationMixin],
  props: {
    signers: {
      type: Object,
      default: () => ({})
    },
    agentUsername: {
      type: String,
      default: null
    },
    currentTemplateData: {
      type: Object,
      default: () => ({})
    }
  },
  validations: {
    newSigner: {
      name: {
        required
      },
      email: {
        required,
        email,
        unique: function (value) {
          var _context;
          return !_findInstanceProperty(_context = this.signersValues).call(_context, ({
            email
          }) => email === value);
        }
      },
      role: {
        required: requiredIf(function () {
          return this.templateSelected;
        })
      }
    },
    signers: {
      required,
      $each: {
        role: {
          required
        },
        email: {
          required,
          email
        }
      }
    }
  },
  data() {
    return {
      newSigner: {
        email: "",
        name: "",
        role: null
      }
    };
  },
  computed: {
    signersValues() {
      return _Object$values(this.signers);
    },
    amountOfSignerRoles() {
      return this.currentTemplateData.signerRoles.length;
    },
    amountOfApplicationSigners() {
      return this.signersValues.length;
    },
    templateSelected() {
      return !!this.currentTemplateData.eSignTemplateId;
    },
    assignedRoles() {
      var _context2;
      return _mapInstanceProperty(_context2 = this.signersValues).call(_context2, signer => signer.role);
    },
    signersWithoutRole() {
      var _context3;
      return _filterInstanceProperty(_context3 = this.signersValues).call(_context3, signer => !signer.role);
    },
    allRoles() {
      return map(this.currentTemplateData.signerRoles, role => role.name);
    },
    enoughSignerRoles() {
      var _context4;
      if (!this.templateSelected || !_filterInstanceProperty(_context4 = this.assignedRoles).call(_context4, role => role).length) return true;
      return this.amountOfSignerRoles >= this.amountOfApplicationSigners;
    },
    signerRolesAvailable() {
      var _context5;
      return _mapInstanceProperty(_context5 = this.allRoles).call(_context5, role => {
        var _context6;
        return {
          label: role,
          value: role,
          disabled: _includesInstanceProperty(_context6 = this.assignedRoles).call(_context6, role)
        };
      });
    },
    allRolesDisabled() {
      if (!this.templateSelected) return false;
      return this.signerRolesAvailable.every(role => role.disabled);
    },
    newSignerValid() {
      return !this.$v.newSigner.$invalid;
    },
    allSignersValid() {
      return !this.$v.signers.$invalid;
    },
    table() {
      const columns = ["name", "email", "role", "action"];
      const headings = {
        name: this.$t("e-sign-package.signerName"),
        email: capitalize(this.$tc("global.words.email", 1)),
        role: this.$tc("e-sign-package.signerType", 1),
        action: ""
      };
      const columnsClasses = {
        name: "w-30",
        email: this.templateSelected ? "w-30" : "w-90",
        role: "w-30",
        action: "w-10 text-center"
      };
      if (!this.templateSelected) {
        _spliceInstanceProperty(columns).call(columns, _indexOfInstanceProperty(columns).call(columns, "role"), 1);
        delete headings.role;
        delete columnsClasses.role;
        columnsClasses.action = "w-10 text-right";
      }
      return {
        columns,
        options: {
          filterable: false,
          sortable: [],
          headings,
          perPage: 999999,
          tabbable: false,
          skin: "table mb-0",
          columnsClasses
        }
      };
    }
  },
  watch: {
    allSignersValid: {
      handler(value) {
        this.$emit("valid", value);
      },
      immediate: true
    }
  },
  mounted() {
    if (!this.templateSelected) {
      this.setDefaultSignersType();
    }
  },
  methods: {
    handleDelete(email) {
      const signers = cloneDeep(this.signers);
      delete signers[email];
      this.$emit("signers-change", signers);
    },
    handleAddSigner: debounce(function () {
      if (!this.newSignerValid) return;
      const signers = cloneDeep(this.signers);
      signers[this.newSigner.email] = cloneDeep(this.newSigner);
      this.$emit("signers-change", signers);
      this.resetFields();
    }, 100),
    resetFields() {
      this.newSigner = {
        name: "",
        email: "",
        role: this.templateSelected ? "" : "Client"
      };
    },
    setDefaultSignersType() {
      this.newSigner.role = "Client";
    }
  }
});